import { useEventLogging } from '@AppModels/Logging';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';

import * as React from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AppImportContactsViewModel, IBulkContactsRequest } from '../../../../viewmodels/AppViewModels';
import { ContactsSelfImportMapping } from '../ContactsSelfImportMapping';
import { ContactsSelfImportProcessing } from '../ContactsSelfImportProcessing';
import { ContactsSelfImportUpload } from '../ContactsSelfImportUpload';
import { styleSheet } from './styles';

interface Props {
	onRequestClose?: (filter?: IBulkContactsRequest) => void;
	completedBtnText?: string;
}

function _ContactsSelfImport({ onRequestClose, completedBtnText }: Props) {
	const { logPageView } = useEventLogging();
	const userSession = useUserSession();
	const [importContacts] = React.useState(() => new AppImportContactsViewModel(userSession));
	const [step, setStep] = React.useState<'upload' | 'map' | 'processing'>('upload');

	React.useEffect(() => {
		logPageView('ContactsSelfImport');
	}, [logPageView]);

	return (
		<div className={`${css(styleSheet.container, step === 'upload' ? styleSheet.containerVariableHeight : null)}`}>
			{step === 'upload' ? (
				<ContactsSelfImportUpload
					className={css(styleSheet.content, styleSheet.uploadContent)}
					importContacts={importContacts}
					onNextButtonClicked={() => setStep('map')}
				/>
			) : null}
			{step === 'map' ? (
				<ContactsSelfImportMapping
					className={css(styleSheet.content, styleSheet.mapContent)}
					importContacts={importContacts}
					onImportClicked={() => setStep('processing')}
					showMergeByNameCheckbox={true}
				/>
			) : null}
			{step === 'processing' ? (
				<ContactsSelfImportProcessing
					className={css(styleSheet.content, styleSheet.importContent)}
					importContacts={importContacts}
					onRequestClose={onRequestClose}
					completedBtnText={completedBtnText}
				/>
			) : null}
		</div>
	);
}

export const ContactsSelfImport = observer(_ContactsSelfImport);
